import {getUseQueryResultData} from "../../../util/selector-util";
import {createSelector} from "@reduxjs/toolkit";
import {TeamMembership, TeamMembershipEntity} from "../../../model/team-membership";

export interface TeamMembershipSelectorProps {

}

export const teamMembershipsSelector = () => createSelector(
  [getUseQueryResultData<TeamMembership[]>],
  (data) => {
    return selectTeamMembershipsAndTransform(
      data ?? [], {}
    );
  }
);

export const selectTeamMemberships = (values?: TeamMembership[], selector?: TeamMembershipSelectorProps): TeamMembership[] => {
  if (!values) {
    return [];
  }

  return values;
};

export const transformTeamMembership = (value: TeamMembership): TeamMembershipEntity => {
  return TeamMembershipEntity.from(value)
}

export const selectTeamMembershipsAndTransform = (values?: TeamMembership[], selector?: TeamMembershipSelectorProps): TeamMembershipEntity[] => {
  const selected = selectTeamMemberships(values, selector);
  return selected.map(transformTeamMembership);
};
